import React from "react";
import { Typography, Button, makeStyles } from "@material-ui/core";
import ErrorImage from "../image/error/error.png";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  containerfluid: {
    width: "100%",
    marginTop: "3rem",
    marginBottom: "15rem",
  },
  container: {
    maxWidth: "1250px",
    margin: "0 auto",
  },
  onlineeducationmain: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  onlineeducationimgcontainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& img": {
      width: "60%",
      [theme.breakpoints.down("xs")]: {
        width: "90%",
      },
    },
  },
  onlineeducationcontentinner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    "& .MuiTypography-h5": {
      fontFamily: "'Playfair Display', serif !important",
      color: "#000",
      fontSize: "2rem",
      fontWeight: "700",
      [theme.breakpoints.down("xs")]: {
        fontSize: "2rem",
        marginTop: "3rem",
      },
    },
    "& .MuiTypography-body2": {
      fontFamily: "'Jost', sans-serif",
      color: "#7E7E7E",
      fontSize: "1rem",
      textAlign: "center",
      whiteSpace: "nowrap",
      fontWeight: "400",
      [theme.breakpoints.down("xs")]: {
        fontSize: "13px",
      },
    },
  },

  InfoButton: {
    background: "rgba(255, 102, 54, 1)",
    color: "#fff",
    width: "240px",
    height: "56px",
    fontWeight: "bold",
    fontSize: "1rem",
    padding: "0.8rem 1.2rem",
    borderRadius: "5px",
    transition: "background 0.3s ease",
    marginTop: "1rem",
    "&:hover": {
      background: "linear-gradient(270deg, #FF8008 0%, #FFC837 74.71%)",
    },
  },
}));

function ErrorPage() {
  const classes = useStyles();
  return (
    <div className={classes.containerfluid}>
      <div className={classes.container}>
        <div className={classes.onlineeducationmain}>
          <div className={classes.onlineeducationimgcontainer}>
            <img src={ErrorImage} alt="img" width="60%" />
          </div>
          <div className={classes.onlineeducationcontentinner}>
            <Typography variant="h5" gutterBottom>
              OOPS! Page Not Found
            </Typography>
            <Typography variant="body2" gutterBottom>
              Something Went Wrong. It's look that your requested could not
              <br></br>
              be found. It's look like the link is broken or the page is
              <br></br>
              removed
            </Typography>
            <Link to="/">
              <Button className={classes.InfoButton}>GO BACK</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
